import config from '../../config';

export const createLocalLink = (url) => {
  if (url === '#') {
    return null;
  }
  return url ? url.replace(config.siteUrl, '') : url;
};

export const dataLayerPush = (data) => {
  if (typeof window === 'undefined' || !window.dataLayer) return;
  window.dataLayer.push(data);
};

export const trailingSlash = (url) => {
  return url.endsWith('/') ? url : `${url}/`;
};

export const decodeEntities = (string) =>
  string
    .replace(/&quot;/g, '"')
    .replace(/&gt;/g, '>')
    .replace(/&lt;/g, '<')
    .replace(/&amp;/g, '&')
    .replace(/&#(\d+);/g, (match, dec) => {
      return String.fromCharCode(dec);
    });
